// extracted by mini-css-extract-plugin
export default {"aside":"HNhlV","scope--has-spacing":"lgFXL","content":"dyypZ","scope":"_9FDN4","scope--sidebar-position-right":"qtE73","scope--sidebar-position-left":"PH1DS"};